import React from "react";
import { Route, Routes } from "react-router-dom";
import PersonalisationUpload from "../components/PersonalisationUpload";

export const PersonalisationRoutes = () => {
  return (
    <Routes>
      <Route path="upload" element={<PersonalisationUpload />} />
    </Routes>
  );
};
